import * as types from "types/actions/screen"
import { Screen } from "store/serializers/screen"

const screenInitialState = {
  screen: {}
}

export default (state = screenInitialState, action) => {
  let newScreen
  switch (action.type) {
    case types.SCREEN_INIT:
      newScreen = new Screen()
      return {
        ...state,
        screen: newScreen
      }
    case types.SCREEN_TEMPLATE_CLEAR:
      const { name, id } = state.screen
      return {
        ...state,
        screen: {
          name,
          id
        }
      }
    case types.SCREEN_COLOR_SET:
      return {
        ...state,
        screen: {
          ...state.screen,
          color: action.color
        }
      }
    case types.SCREEN_UPDATE:
      return {
        ...state,
        screen: {
          ...state.screen,
          ...action.screen
        }
      }
    case types.SCREEN_TEMPLATE_SET:
      return {
        ...state,
        screen: {
          ...state.screen,
          template: action.template
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/screen.js